import React from 'react';
import Checkbox from '@amzn/meridian/checkbox';
import Box from '@amzn/meridian/box';
import { FormattedMessage } from 'react-intl';
import Row from '@amzn/meridian/row';
import Column from '@amzn/meridian/column';

export type CheckboxItem = {
  checked: boolean;
  labelText: string;
  labelId: string;
  additionalLabelText?: string;
  onClick?: (...args: any) => void;
};

interface RenderCheckboxesFromConfig {
  checkboxes: CheckboxItem[];
  styles?: Partial<{
    parentContainer: any;
    checkbox: any;
    label: any;
  }>;
  onChange: (id: string, checked: boolean) => void;
}
const RenderCheckboxesFromConfig: React.FC<RenderCheckboxesFromConfig> = ({
  checkboxes,
  styles,
  onChange,
}: RenderCheckboxesFromConfig) => {
  return (
    <Box className={styles?.parentContainer}>
      {checkboxes.map(checkbox => (
        <Checkbox
          checked={checkbox.checked}
          onChange={() => {
            if (checkbox.onClick) checkbox.onClick(!checkbox.checked);
            return onChange(checkbox.labelId, !checkbox.checked);
          }}
        >
          <FormattedMessage
            id={checkbox.labelId ?? ''}
            defaultMessage={checkbox.labelText}
          />
          {checkbox?.additionalLabelText && (
            <>&nbsp;{checkbox?.additionalLabelText}</>
          )}
        </Checkbox>
      ))}
    </Box>
  );
};

export default RenderCheckboxesFromConfig;
